/* @flow */
import * as t from './actionTypes';
import type { NewTripRequest } from '../../data/TripRequests';

const InitialState: { newTripRequest: NewTripRequest } = {
  newTripRequest: {
    contacts: [],
    day: null,
    description: null,
    destinationId: null,
    fareEstimateId: null,
    fromTime: null,
    originId: null,
    paymentSourceId: null,
    photoUrls: [],
    product: null,
    toTime: null,
  },
  // newTripRequest: {
  //   day: moment('2017-08-19T07:00:00.000Z', moment.ISO_8601),
  //   description: null,
  //   destinationId: '2c199bfd-5930-424b-9b9e-1109ea004989',
  //   fareEstimateId: 'daab7dcd-97d7-4851-ac01-7183e5a284af',
  //   fromTime: moment('2017-08-19T16:00:00.000Z', moment.ISO_8601),
  //   originId: '6524c7f1-6bc1-4856-85c3-1ec429ec641b',
  //   paymentSourceId: null,
  //   product: 'pickup',
  //   toTime: moment('2017-08-19T17:00:00.000Z', moment.ISO_8601),
  // },
};

export default function tripRequests(state: Object = InitialState, action: Object) {
  switch (action.type) {
    case t.RESET_NEW_TRIP_REQUEST:
      return {
        ...state,
        newTripRequest: {
          ...InitialState.newTripRequest,
          created: action.created,
        },
      };
    case t.RESET_CREATED_NEW_TRIP_REQUEST:
      return {
        ...state,
        newTripRequest: {
          ...state.newTripRequest,
          created: null,
        },
      };
    case t.SET_NEW_TRIP_REQUEST_CONTACTS:
      return {
        ...state,
        newTripRequest: {
          ...state.newTripRequest,
          contacts: action.contacts,
        },
      };
    case t.SET_NEW_TRIP_REQUEST_USE_CASE:
      return {
        ...state,
        newTripRequest: {
          ...state.newTripRequest,
          useCase: action.useCase,
        },
      };
    case t.SET_NEW_TRIP_REQUEST_PARTNER_SESSION:
      return {
        ...state,
        newTripRequest: {
          ...state.newTripRequest,
          partner: action.partner,
          sessionId: action.sessionId,
        },
      };
    case t.SET_NEW_TRIP_REQUEST_DAY:
      return {
        ...state,
        newTripRequest: {
          ...state.newTripRequest,
          day: action.day.toISOString(true),
        },
      };
    case t.SET_NEW_TRIP_REQUEST_TIME:
      return {
        ...state,
        newTripRequest: {
          ...state.newTripRequest,
          fromTime: action.fromTime.toISOString(true),
          toTime: action.toTime.toISOString(true),
        },
      };
    case t.SET_NEW_TRIP_REQUEST_ON_DEMAND:
      return {
        ...state,
        newTripRequest: {
          ...state.newTripRequest,
          onDemand: action.onDemand,
          label: action.label,
        },
      };
    case t.SET_NEW_TRIP_REQUEST_FARE_ESTIMATE_ID:
      return {
        ...state,
        newTripRequest: {
          ...state.newTripRequest,
          fareEstimateId: action.fareEstimateId,
        },
      };
    case t.SET_NEW_TRIP_REQUEST_DESCRIPTION:
      return {
        ...state,
        newTripRequest: {
          ...state.newTripRequest,
          description: action.description,
        },
      };
    case t.SET_NEW_TRIP_REQUEST_PAYMENT_SOURCE_ID:
      return {
        ...state,
        newTripRequest: {
          ...state.newTripRequest,
          paymentSourceId: action.paymentSourceId,
        },
      };
    case t.SET_NEW_TRIP_REQUEST_ORIGIN_ID:
      return {
        ...state,
        newTripRequest: {
          ...state.newTripRequest,
          originId: action.originId,
        },
      };
    case t.SET_NEW_TRIP_REQUEST_DESTINATION_ID:
      return {
        ...state,
        newTripRequest: {
          ...state.newTripRequest,
          destinationId: action.destinationId,
        },
      };
    case t.SET_NEW_TRIP_REQUEST_PRODUCT:
      return {
        ...state,
        newTripRequest:
          action.product !== state.newTripRequest.product
            ? {
                ...state.newTripRequest,
                product: action.product,
                fromTime: null,
                toTime: null,
                fareEstimateId: null,
              }
            : state.newTripRequest,
      };
    case t.SET_NEW_TRIP_REQUEST_PROMO_CODE:
      return {
        ...state,
        newTripRequest: {
          ...state.newTripRequest,
          promoCode: action.promoCode,
        },
      };
    case t.SET_NEW_TRIP_REQUEST_QUERY_STRING:
      return {
        ...state,
        newTripRequest: {
          ...state.newTripRequest,
          queryString: action.queryString,
        },
      };
    case t.ADD_NEW_TRIP_REQUEST_PHOTO:
      return {
        ...state,
        newTripRequest: {
          ...state.newTripRequest,
          photoUrls: [...(state.newTripRequest.photoUrls || []), action.url],
        },
      };
    case t.REMOVE_NEW_TRIP_REQUEST_PHOTO:
      return {
        ...state,
        newTripRequest: {
          ...state.newTripRequest,
          photoUrls: state.newTripRequest.photoUrls.filter(url => url !== action.url),
        },
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/trip-requests/reducer.js